import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Entity} from '../../models/entity';
import {Message} from '../../models/message';
import {MessagesService} from '../../services/messages/messages.service';
import {ChatComponent} from '../chat/chat.component';
import {UserService} from '../../services/user/user.service';
import {NewMessageObserverService} from '../../services/new-message-observer/new-message-observer.service';
import {ApiService} from '../../services/api/api.service';
import * as moment from 'moment';
import * as matchAll from 'match-all';
import Relator from '../../helpers/relator/relator';
import {sortByNewestTimestamp} from '../../helpers/message-display/message-display';

@Component({
    selector: 'ngx-chat-channel',
    templateUrl: './chat-channel.component.html',
    styleUrls: ['./chat-channel.component.scss'],
})
export class ChatChannelComponent implements OnInit, OnChanges, OnDestroy {
    @Input() entity: Entity = null;
    @Input('messageType') messageType: string = 'chat';

    @ViewChild('chatComponent') chatComponent: ChatComponent;

    public messages: any[] = null;
    public message: string = '';
    public sending: boolean = false;

    private currentChannel = null;
    public messagesCall = {
        limit: 100,
        page: 1,
        maxPages: 1,
        loading: false,
    }

    constructor(
        private messenger: MessagesService,
        public user: UserService,
        private api: ApiService,
        private newMessageObserverService: NewMessageObserverService,
    ) {
    }

    ngOnInit() {
        this.loadInitialMessages();
    }

    private processMessage(message: Message) {
        const matches = matchAll(message.body, /<img src="(.*?)"/gi).toArray();

        for (const match of matches) {
            const image = {
                url: match
            };
            message.images.push(image);
        }

        message.body = message.body.replace(/<img src="(.*?)"\/>/gi, '');
        message.body = message.body.replace(/<p>\s*<\/p>/gi, '');

        message.body = message.body.replace(/(<br\/>)+$/gi, '');
        return message;
    }

    public loadInitialMessages() {
        const vm = this;
        this.messages = [];
        this.messagesCall.loading = true;
        this.messagesCall.page = 1;
        this.messagesCall.maxPages = 1;

        if (!this.entity) {
            this.messagesCall.loading = false;
            return;
        }

        // Basically, get all the messages from the API.
        this.messenger.all(this.entity, vm.messageType, vm.messagesCall.limit, vm.messagesCall.page)
            .then(data => {
                const unsorted_messages = [];

                for (const message of data['data']) {
                    unsorted_messages.push(this.processMessage(message));
                }

                vm.messages = sortByNewestTimestamp(unsorted_messages, ['created_at']);
                vm.messagesCall.loading = false;
                vm.messagesCall.page++;
                vm.messagesCall.maxPages = 1; // data['meta']['last_page']; All means there really isn't any pagination.

                vm.currentChannel = vm.newMessageObserverService.subscribe(pushedMessage => {
                    vm.onMessageSent(pushedMessage);
                });
            }, () => {
                vm.messagesCall.loading = false;
            });
    }

    onMessageSent(pushedMessage) {
        const vm = this;
        if (pushedMessage.entity.id === vm.entity.id) {
            Relator.addOnce(pushedMessage.message, vm.messages);
            vm.messages = sortByNewestTimestamp(vm.messages, ['created_at']);
            vm.setEntityMessagesSeen();
            if (pushedMessage.message.user.id === vm.user.currentUser.id) {
                vm.sending = false;
            }
            this.chatComponent.scrollToBottom();
        }
    }

    private messagesNextPage() {
        // We already just load everything on first load, so this is no longer needed.

        // const vm = this;
        // if (vm.messagesCall.page <= vm.messagesCall.maxPages) {
        //   vm.messagesCall.loading = true;
        //   vm.messenger.all(vm.entity, vm.messageType, vm.messagesCall.limit, vm.messagesCall.page)
        //     .then(data => {
        //       for (const message of data.data) {
        //         if (!vm.messageIdExists(message.id)) {
        //           vm.messages.unshift(message);
        //         }
        //       }
        //       vm.messagesCall.loading = false;
        //       vm.messagesCall.page++;
        //     });
        // }
    }

    onMessagesScrollUp() {
        this.messagesNextPage();
    }

    // Message received from server
    onMessage(message) {
        if (this.user != null && message != null) {
            // Don't trigger on own messages
            let found = message.user.id === this.user.currentUser.id;

            // Loop over all messages and check if we don't have this one yet
            for (let i = 0; i < this.messages.length; i++) {
                const _imsg = this.messages[i];
                if (_imsg.id === message.id) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.messages.unshift(message);
            }
        }
    }

    private onEntityChanged() {
        this.loadInitialMessages();
        this.setEntityMessagesSeen();
        this.unsubscribeFromNewMessages();
    }

    private setEntityMessagesSeen() {
        const vm = this;

        if (this.entity) {
            this.api.post('v1/entities/' + this.entity.id + '/messages/' + this.messageType + '/seen', {
                entity: this.entity.id,
                type: this.messageType,
            }).then(() => {
                vm.newMessageObserverService.refreshUnreadCount();
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // const entity: SimpleChange = changes.entity;
        this.onEntityChanged();
    }

    send() {
        const vm = this;
        const messageToSend = vm.message;

        vm.message = '';
        vm.sending = true;

        const message = new Message();
        message.body = messageToSend;
        message.type = 'chat';
        message.user = this.user.currentUser;
        const date = moment().format('YYYY-MM-DD HH:mm::ss');
        message.created_at = date;
        // vm.messages.push(message);

        this.messenger.send([this.entity], messageToSend, vm.messageType, []).then(data => {
            vm.sending = false;
        });
    }

    unsubscribeFromNewMessages() {
        if (this.currentChannel) {
            this.currentChannel.unsubscribe();
        }
    }

    ngOnDestroy() {
        this.unsubscribeFromNewMessages();
    }

    messageKeyPress(e, vm) {
        if (e.keyCode === 13) {
            vm.send();
        }
    }

}
